'use client';

import LocationMap from '@/features/warehouses/components/LocationMap';

const WAREHOUSE_LOCATIONS = {
  '경인냉장': '경기도 광주시 경충대로 1502 (쌍령동)',
  '대재냉장': '경기도 광주시 초월읍 두둘기길 33',
  '대청냉장': '경기도 광주시 초월읍 산수로 370 (신월리)',
  '미빙냉장': '경기도 광주시 장지9길 74 (장지동)',
  '삼일냉장': '경기도 광주시 곤지암읍 경충대로311번길 17 (수양리)',
  '삼진1냉장': '경기도 광주시 경충대로 1801 (장지동)',
  '삼진2냉장': '경기도 광주시 장지9길 64 (장지동)',
  '새영기업(우일)': '경기도 광주시 경충대로 2210 (삼동)',
  '서울물류': '경기도 광주시 경충대로 1425 (쌍령동)',
  '세원CS': '경기도 광주시 초월읍 경충대로 1146 (쌍동리)',
  '신우냉장': '경기도 광주시 도척면 국사봉로 75 (진우리)',
  '오아시스(견우푸드)': '경기도 광주시 곤지암읍 경충대로498번길 131',
  '한솔냉장': '경기도 광주시 장지9길 34-16 (장지동)',
  '효성냉장': '경기도 광주시 순암로 536-7 (삼동)',
  'HL곤지암': '경기도 광주시 도척면 도척로 401-98 (진우리)',
  'SWC': '경기도 광주시 도척면 국사봉로 97-27 (진우리)',
  '강동1냉장': '경기도 용인시 기흥구 동탄기흥로 776',
  '강동2냉장': '경기도 용인시 기흥구 농서로 51 (농서동)',
  '고려냉장': '경기도 용인시 기흥구 덕영대로 1994 (상갈동)',
  '남사물류': '경기도 용인시 처인구 남사읍 처인성로 1027 (완장리)',
  '동경냉동': '경기도 용인시 처인구 포곡읍 성산로 600 (전대리)',
  '베이지박스투(요진TF)': '경기도 용인시 기흥구 고매로43번길 1 (공세동)',
  '세미냉장(이스트벨리)': '경기도 용인시 기흥구 동탄기흥로681번길 1(고매동)',
  '연세(세종)냉장': '경기도 용인시 기흥구 기곡로 22 (하갈동)',
  '아워홈': '경기도 용인시 처인구 남사읍 당하로 154 (북리)',
  '아이린(양지선일)': '경기도 용인시 처인구 양지면 중부대로 2605 (추계리)',
  '에이스기흥': '경기도 용인시 기흥구 원고매로 29 (고매동)',
  '에이스용인': '경기도 용인시 기흥구 중부대로 714 (상하동)',
  '에이스처인': '경기도 용인시 처인구 중부대로 1022-1 (삼가동)',
  '오로라CS': '경기도 용인시 기흥구 중부대로684번길 14 (상하동)',
  '유상': '경기도 용인시 기흥구 동탄기흥로 741 (고매동)',
  '프라자': '경기도 용인시 처인구 남사읍 경기동로 55 (북리)',
  '희창': '경기도 용인시 처인구 모현읍 포은대로 892 (오산리)',
  'CH': '경기도 용인시 기흥구 하갈로 141-17 (상갈동)',
  '그레이박스': '경기도 안산시 단원구 해봉로 232 (성곡동, GREYBOX안산물류센터)',
  '글로벌냉동1물류': '경기도 안성시 보개면 남사당로 71 (불현리)',
  '글로벌냉동2물류': '경기도 안성시 보개면 너리굴길 16',
  '다이아몬드냉장': '경기도 성남시 중원구 둔촌대로456번길 7 (상대원동)',
  '더본냉장': '경기도 오산시 동부대로 468-31 (원동)',
  '도지냉장': '이천시 백사면 청백리로 287',
  '동원이천': '경기도 이천시 호법면 중부대로763번길 141-27 (안평리)',
  '동일냉장': '경기도 이천시 신둔면 경충대로 3035 (수남리)',
  '로얄냉장': '경기도 성남시 분당구 대왕판교로 95 (금곡동)',
  '롯데물류': '경기도 이천시 마장면 이장로311번길 91 (장암리)',
  '사조냉장': '서울 금천구 두산로7길 13',
  '신영(여주)': '경기도 여주시 삼교1길 9-7 (삼교동)',
  '인천로지스틱스': '인천광역시 중구 축항대로117번길 21 (항동7가)',
  '일죽(냉동)냉동': '경기도 안성시 일죽면 사실로 161-41 (방초리)',
  '일죽(냉장)냉동': '경기도 안성시 일죽면 사실로 161-41 (방초리)',
  '정양냉장': '경기도 이천시 마장면 둔터로 24-26 (장암리)',
  '삼영(수원한솔)': '경기도 수원시 권선구 오목천로132번길 55 (고색동)',
  'HL동탄': '경기도 화성시 동탄물류로 103 (신동)',
  '고려물류(부산)': '부산광역시 사하구 다대로 332 (장림동)',
  '삼일냉장(부산)': '부산광역시 사하구 서포로 36 (구평동)',
  '삼진냉장(부산)': '부산광역시 사하구 장평로 269 (신평동)',
  '한일냉장1(부산)': '부산광역시 사하구 원양로 319 (감천동)',
  '한일냉장2(부산)': '부산광역시 사하구 원양로 314 (감천동)',
};

export default function WarehousesPage() {
  return (
    <div className="container">
      <LocationMap locations={WAREHOUSE_LOCATIONS} />
    </div>
  );
}
